import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchContactsData = createAsyncThunk(
    'contact/fetchContactsData',
    async () => {
        try {
            const response = await api.get('/contact');
            return response.data.data;
        } catch (error) {
            return error;
        }

    }
)

export const settingContactSlice = createSlice({
    name: "contact",
    initialState: {
        loading: false,
        error: null,
        contacts: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchContactsData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchContactsData.fulfilled, (state, action) => {
                state.loading = false;
                state.contacts = action.payload;
            })
            .addCase(fetchContactsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export default settingContactSlice.reducer;
